import { DataAnalyticsTaggingEvent, DataAnalyticsTaggingEvents, DataAnalyticsTaggingEventType } from '@tdwb/core';

const registerModalPages = [ 'webinar', 'master-class' ]
const registerSteps = [ '', 'confirmation']
export class LearnAnalytics {
  static getLinkClickEventData(name: string): DataAnalyticsTaggingEvent {
    return {
      event: DataAnalyticsTaggingEventType.LINK_CLICK,
      link: {
        name,
        type: 'link'
      }
    };
  }

  static getVideoPageEventData(lessonType: string, section: string, title: string): DataAnalyticsTaggingEvent {
    return {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: lessonType,
        subSection1: 'learn',
        subSection2: lessonType,
        customPageName: `wb_learn-${lessonType}`,
        videoSection: section,
        mediaName: title,
        mediaType: 'video'
      }
    }
  }

  static getQuestionaireEventData(stepIndex: string): DataAnalyticsTaggingEvent {
    return {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: `td-wb-learn-questionnaire-${stepIndex}`,
        subSection1: 'learn',
        subSection2: `td-wb-learn-questionnaire-${stepIndex}`,
        customPageName: `wb_learn-path-modal-${stepIndex}`
      }
    }
  }

  static modalEvents: DataAnalyticsTaggingEvents = {
    modalLearnCongratulations: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'td-wb-learn-congratulations',
        subSection1: 'learn',
        subSection2: 'td-wb-learn-congratulations',
        customPageName: 'wb_learn-path-modal-congratulations'
      }
    },
    ...this.addLearnRegisterModals()
  }

  static taggingEvents: DataAnalyticsTaggingEvents = {
    pageLearnWelcome: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'welcome',
        subSection1: 'learn',
        subSection2: 'welcome',
        customPageName: 'wb_learn-welcome'
      }
    },
    pageLearnOn_Demand: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'on-demand',
        subSection1: 'learn',
        subSection2: 'on-demand',
        customPageName: 'wb_learn-on-demand'
      }
    },
    pageLearnLearning_Path: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'learning-path',
        subSection1: 'learn',
        subSection2: 'learning-path',
        customPageName: 'wb_learn-learning-path'
      }
    },
    pageLearnMasterclasses: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'master-classes',
        subSection1: 'learn',
        subSection2: 'master-classes',
        customPageName: 'wb_learn-master-classes'
      }
    },
    pageLearnWebinars: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'webinars',
        subSection1: 'learn',
        subSection2: 'webinars',
        customPageName: 'wb_learn-webinars'
      }
    },
    ...this.modalEvents
  }

  private static addLearnRegisterModals(): DataAnalyticsTaggingEvents{
    const modalRegisterEvents: DataAnalyticsTaggingEvents = {};
    registerModalPages.forEach((page: string)=>{
      registerSteps.forEach((step: string)=>{
        let stateKey = `modal.learn.${page}.register`;
        let modalName = `register-${page}-modal`

        if (step.length !== 0){
          stateKey = stateKey.concat(`-${step}`)
          modalName = modalName.replace('modal', `${step}-modal` );
        }

        modalRegisterEvents[stateKey] = {
          event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
          page: {
            modalName,
            subSection1: 'learn',
            subSection2: modalName,
            customPageName: `wb_learn-${modalName}`
          },
          process: {
            processName: 'tdw:wbt:learn:registration',
            processType: `tdw:wbt:learn:registration:${step.length === 0 ? 'start' : 'complete'}`
          }
        };
      });
    });

    return modalRegisterEvents;
  }

}
